import { Role, RoleType } from 'common/src/generated/types';

export function isEditable(role: Pick<Role, 'type'>) {
    return role.type === RoleType.Custom;
}
